"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { afterInitialPaint } from "@/lib/after-initial-paint";

export function Analytics() {
  const pathname = usePathname();
  useEffect(() => {
    let disposed = false;
    afterInitialPaint(() => {
      if (!disposed) void import("@/lib/analytics-client").then(({ initializeAnalytics, trackPageView }) => {
        if (!disposed) { initializeAnalytics(); trackPageView(); }
      }).catch(() => {});
    });
    return () => { disposed = true; };
  }, [pathname]);
  return null;
}
